import React from 'react';
import { DraggableProvided } from 'react-beautiful-dnd';
import { HiOutlineSwitchVertical } from 'react-icons/hi';
import { Flex, Icon, Text } from '@chakra-ui/react';
import { DotOptions } from '../DotOptions';

interface CategorieItemProps {
  title: string;
  itemRef: DraggableProvided['innerRef'];
  id: string;
  modalFunc: () => void;
}

export const CategorieItem: React.FC<CategorieItemProps> = ({
  title,
  itemRef,
  id,
  modalFunc,
  ...rest
}) => {
  return (
    <Flex
      ref={itemRef}
      py="8px"
      pl="8px"
      pr="2px"
      borderRadius="6px"
      key={title}
      align="center"
      {...rest}
    >
      <Icon color="black" as={HiOutlineSwitchVertical} />
      <Text ml="8px" textColor="text.100" noOfLines={1} fontSize="14px">
        {title}
      </Text>

      <DotOptions modalFunc={modalFunc} id={id} />
    </Flex>
  );
};
